import axios from 'axios';
import _ from 'lodash';

export default () => (dispatch, getState) => {

  axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
  }

  axios.defaults.authWithToken = true;

  axios.interceptors.request.use(config => {

    if (!config.authWithToken) return config;

    return _.merge({}, config, {
      headers: {
        Authorization: `Bearer ${getState().token}`
      }
    });
    
  });

}